const normalizeModerationStatus = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');

const synthesizeModerationRecordsFromEventStatus = (event) => {
  const status = normalizeModerationStatus(event?.status);
  if (!status || status === 'draft') {
    return [];
  }

  const createdAt = event?.submittedAt ?? event?.createdAt ?? null;
  const updatedAt = event?.updatedAt ?? createdAt;

  if (status === 'pending') {
    return [{ status: 'pending', requestedAt: createdAt, createdAt }];
  }

  const records = [{ status: 'pending', requestedAt: createdAt, createdAt }];

  if (status === 'requested' || status === 'rejected' || status === 'changes_requested') {
    records.push({ status, requestedAt: updatedAt, updatedAt });
    return records;
  }

  if (status === 'submitted') {
    records.push({ status: 'submitted', requestedAt: updatedAt, updatedAt });
    return records;
  }

  records.push({ status: 'approved', requestedAt: updatedAt, updatedAt });

  if (event?.published || status === 'published') {
    records.push({ status: 'published', requestedAt: updatedAt, updatedAt });
  }

  return records;
};

/** Moderation history on list (`moderationRecords`) and detail (`moderationResult`) payloads. */
export const getEventModerationRecords = (event) => {
  if (Array.isArray(event?.moderationRecords) && event.moderationRecords.length > 0) {
    return event.moderationRecords;
  }

  if (Array.isArray(event?.moderationResult) && event.moderationResult.length > 0) {
    return event.moderationResult;
  }

  return synthesizeModerationRecordsFromEventStatus(event);
};
